import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/something-rotten-2022/sponsors/Loge_Gallery_Bagley.jpg',
      link: 'https://www.pioneertheatre.org/loge-gallery',
      alt: 'Loge Gallery',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/Marriner_Eccles.jpg',
      link: 'https://www.pioneertheatre.org/',
      alt: 'Marriner S. Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/PBS-22.jpg',
      link: 'https://www.pbsutah.org/gerda',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
    {
      image:
        '/something-rotten-2022/sponsors/Something-Rotten-Hello-Dolly-Ad.jpg',
      link: 'https://www.pioneertheatre.org',
      alt: 'Hello Dolly at Pioneer Theatre Company',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/Something-Rotten-Zap.jpg',
      link: 'https://www.pioneertheatre.org',
      alt: 'Thank you',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/U_Giving_SpecialThanks.jpg',
      link: 'https://www.pioneertheatre.org/givingday',
      alt: 'Giving Day at PTC University of Utah',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/Upcoming-Fireflies.jpg',
      link: 'https://www.pioneertheatre.org/',
      alt: 'Fireflies',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/zions_bank.jpg',
      link: 'https://zionsbank.com',
      alt: 'Zions Bank',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/George_Dolores_Eccles.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'George S. and Dolores Doré Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/Andrea_Golding.jpg',
      link: 'https://pioneertheatre.org/',
      alt: 'Andrea Golding Legacy Foundation thank you',
      class: 'webFormat',
    },
    {
      image: '/something-rotten-2022/sponsors/George_Dolores_Eccles.jpg',
      link: 'https://pioneertheatre.org/augie',
      alt: 'Augie Mericola tribute',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
